import { render, staticRenderFns } from "./ProjectSideNav.vue?vue&type=template&id=566a43a8&scoped=true&"
import script from "./ProjectSideNav.vue?vue&type=script&lang=js&"
export * from "./ProjectSideNav.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSideNav.vue?vue&type=style&index=0&id=566a43a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a43a8",
  null
  
)

export default component.exports